// Product fields shared by the Create Product wizard (ProductFormPage) and
// Create Related Listing.

export interface ProductContactOption {
  key: string;
  value: string;
  text: string;
}

export const PRODUCT_CONTACT_OPTIONS: ProductContactOption[] = [
  {
    key: "Patrick Klotzbach",
    value: "Patrick Klotzbach",
    text: "Patrick Klotzbach",
  },
  { key: "Robyn Baun", value: "Robyn Baun", text: "Robyn Baun" },
  { key: "Jonathan Briggs", value: "Jonathan Briggs", text: "Jonathan Briggs" },
  { key: "Alex Burns", value: "Alex Burns", text: "Alex Burns" },
  { key: "Kayla Winter", value: "Kayla Winter", text: "Kayla Winter" },
  {
    key: "Marissa Carbonell",
    value: "Marissa Carbonell",
    text: "Marissa Carbonell",
  },
];

/** The contact options plus `current` when it isn't one of them (e.g. a
 *  prefilled contact who has left), so a Select can still show it. */
export function productContactOptionsWith(
  current: string | null | undefined
): ProductContactOption[] {
  const value = current?.trim();
  if (!value || PRODUCT_CONTACT_OPTIONS.some((o) => o.value === value)) {
    return PRODUCT_CONTACT_OPTIONS;
  }
  return [...PRODUCT_CONTACT_OPTIONS, { key: value, value, text: value }];
}

// Same limits as ProductFormPage's Yup schema.
export const PRODUCT_TITLE_MIN_LENGTH = 8;
export const PRODUCT_TITLE_MAX_LENGTH = 250;

export function validateProductTitle(title: string): string | null {
  const trimmed = title.trim();
  if (!trimmed) return "Product Title is required";
  if (trimmed.length < PRODUCT_TITLE_MIN_LENGTH) {
    return `Product Title must be at least ${PRODUCT_TITLE_MIN_LENGTH} characters`;
  }
  if (trimmed.length > PRODUCT_TITLE_MAX_LENGTH) {
    return `Product Title must be at most ${PRODUCT_TITLE_MAX_LENGTH} characters`;
  }
  return null;
}
